import AccountHome from './AccountHome'
import enhance from './AccountHome.enhancer'

export default enhance(AccountHome)



// WEBPACK FOOTER //
// ./src/containers/account/AccountHome/index.js